import React from 'react';
import { ShellPanel } from 'web-ui-components/lib/layout/content';
import { ProgressStepper } from 'web-ui-components/lib/navigation/indicators';

export function DisputeProgressComponent(props) {
  const { currentId, items } = props;
  return (
    <ShellPanel>
      <ProgressStepper items={items} currentStepId={currentId} />
    </ShellPanel>
  );
}

DisputeProgressComponent.propTypes = {};
